export default "assets/images/09c3ce5a86d600e24f8e85de3a019853.png";